// extracted by mini-css-extract-plugin
export default {"mCard":"zF-z","image":"AF-z","imageNoBackground":"BF-z","imageHasCategory":"CF-z","fullWidth":"DF-z"};